import { useEffect, useRef, useState } from 'react';
import { FaBuilding, FaBoxOpen, FaGlobeAsia, FaUserMd } from 'react-icons/fa';
import './Stats.css';

const STATS = [
  { icon: <FaBuilding />,  value: '25+',   label: 'Years in Business' },
  { icon: <FaBoxOpen />,   value: '500+',  label: 'Products Available' },
  { icon: <FaGlobeAsia />, value: '40+',   label: 'Countries Served' },
  { icon: <FaUserMd />,    value: '1000+', label: 'Happy Clients' },
];

/** Counts from 0 to the numeric part of `value` when scrolled into view. */
function CountUp({ value }) {
  const match = value.match(/^(\d+)(.*)$/);
  const target = match ? parseInt(match[1], 10) : 0;
  const suffix = match ? match[2] : '';
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setCount(target);
      return;
    }

    let frame;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();

        const duration = 1600;
        const start = performance.now();
        const tick = now => {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setCount(Math.round(target * eased));
          if (progress < 1) frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
      },
      { threshold: 0.5 }
    );

    observer.observe(el);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [target]);

  return <span ref={ref}>{count}{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="stats">
      <div className="container">
        <div className="stats__grid">
          {STATS.map(s => (
            <div className="stats__item" key={s.label}>
              <div className="stats__icon" aria-hidden="true">{s.icon}</div>
              <div className="stats__value"><CountUp value={s.value} /></div>
              <div className="stats__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
